import * as types from "./withdrawalEmailTemplateActionTypes";
import api from "./withdrawalEmailTemplateApi";

export function clearTemplate() {
  return {
    type: types.CLEAR_TEMPLATE,
  };
}

export function getTemplate(path, body, customHeaders) {
  return {
    type: types.GET_TEMPLATE,
    promise: api.getTemplate(path, body, customHeaders),
  };
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/withdrawalEmailTemplateActions.js